import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'heart-image',
  templateUrl: './heart-image.component.html',
  styleUrls: ['./heart-image.component.css']
})
export class HeartImageComponent implements OnInit {

  public visible:boolean = false;
  
  constructor() { }

  ngOnInit() {
  }

}
